import { ComponentType } from 'react';
import Loadable, { LoadingComponentProps } from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "smallScreenFallback" */ './index'),
  loading: (() => null) as ComponentType<LoadingComponentProps>,
});
